import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: [
      "Inter Regular",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    buttonLabel: {
      fontFamily: "Inter Light",
      fontStyle: "italic",
    },
    h5: {
      fontFamily: "Inter SemiBold",
      fontSize: "24px",
      lineHeight: 28 / 26,
    },
    h6: {
      fontFamily: "Inter SemiBold",
      fontSize: "18px",
      lineHeight: 18 / 14,
      fontWeight: "600",
    },
    subtitle2: {
      fontFamily: "Inter Medium",
      fontSize: "14px",
      lineHeight: 14 / 16,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#2d2d2d",
          boxShadow: "none",
          borderBottom: "solid 1px #e3e3e3",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: "56px",
          minHeight: "56px",
          "@media (min-width: 600px)": {
            height: "56px",
            minHeight: "56px",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          lineHeight: 0.5,
          minWidth: "50px",
        },
      },
    },
    // MuiGrid: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: "#F9FAFB"
    //     }
    //   }
    // },
    MuiCssBaseline: {
      styleOverrides: `
        h1 {
          color: red;
        }
      `,
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          body1: "span",
          body2: "span",
        },
      },
      styleOverrides: {
        root: {
          // fontFamily: "Inter Regular",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Inter Regular",
          fontSize: "14px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderColor: "#E4E7EC",
          // color: "red"
        },
      },
    },
  },
  palette: {
    grey: {
      0: "#ffffff",
      10: "#F9FAFB",
      20: "#F2F4F7",
      30: "#E4E7EC",
      40: "#D0D5DD",
      50: "#98A2B3",
      80: "#667085",
      90: "#3E4A62",
      100: "#101828",
    },
    blue: {
      10: "#F6FAFC",
      15: "#EDFAFF",
      20: "#DEF1FA",
      30: "#DBEAF4",
      40: "#C1DFEF",
      45: "#95CCF1",
      50: "#2A93DB",
      60: "#0875B1",
    },
    red: {
      5: "#FFF5F5",
      10: "#FDECEC",
      20: "#FFDEDE",
      50: "#EE3F3F",
      60: "#D21010",
    },
    green: {
      10: "#ECFDF3",
      20: "#C9F6DB",
      50: "#12B76A",
      60: "#05A65B",
    },
    orange: {
      5: "#FFF9F0",
      10: "#FFF4E3",
      20: "#F2A851",
      50: "#ED8A17",
      60: "#DC6803",
    },
  },
});
export default theme;
